module.exports = __webpack_public_path__ + "img/head.c91dc7d1.jpg";